import { useMessage } from '@messageformat/react';
export var useCopy = function useCopy(id, params, locale) {
  return useMessage(id, params, locale);
};